import Vue from "vue";
import Router from "vue-router";
import dmvtabs from "./components/DMVTabs.vue";
import autopaldata from "./components/AutopalData.vue";
//import PaymentInfo from "./views/PaymentInfo.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: dmvtabs,
      name: "dmvtabs"
    },
    {
      path: "/autopaldata",
      component: autopaldata,
      name: "autopaldata"
    }
    // {
    //   path: "/paymentinfo",
    //   component: PaymentInfo,
    //   name: "paymentinfo"
    // }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
